import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const BUSINESS_WA = process.env.REACT_APP_BUSINESS_WHATSAPP || "";
export const BUSINESS_NAME = process.env.REACT_APP_BUSINESS_NAME || "Tech Detailers";

export const waLink = (msg = "Hi Tech Detailers, I'd like to know more.") => {
  const num = BUSINESS_WA.replace(/^\+/, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};
